// Home.js — Router de dashboard
//
// MAPEO DEFINITIVO — coincide con Topbar.js real (verificado línea por
// línea: {userType === 0 ? "Administrador" : "Cliente"}) y con las reglas
// confirmadas por Fernando el 13-ago-2026:
//
// type = 0 → Administrador → ELIGE vista (A o B) al entrar. Ve TODOS los
//            dispositivos, sin importar propietario ni donante.
// type = 1 → Cliente     → SIEMPRE Dashboard A, sin elegir. Ve SOLO los
//            dispositivos de los cuales es propietario (id_user).
// type = 2 → Donante     → TAMBIÉN elige vista (A o B) al entrar.
//            Independientemente de cuál elija, ve los dispositivos de
//            los cuales es propietario Y/O donante (unión, no exclusivo).
//
// El alcance real de qué dispositivos ve cada quien lo deciden los
// endpoints del backend (getDashboardDevices, portfolio/summary) según
// user_type — este archivo solo decide QUÉ VISTA se renderiza.
import React, { useContext, useState } from "react";
import { AuthContext } from "../AuthContext/AuthContext";
import DashboardA from "./DashboardA";
import DashboardB from "./DashboardB";
import "./Home.css";

const DashboardChooser = ({ onChoose }) => (
  <div className="hc-wrapper">
    <div className="hc-card">
      <div className="hc-title">¿Qué vista quieres abrir?</div>
      <div className="hc-subtitle">
        Puedes cambiar de vista después sin cerrar sesión.
      </div>
      <div className="hc-options">
        <button className="hc-option" onClick={() => onChoose("A")}>
          <span className="hc-option-icon">💧</span>
          <span className="hc-option-label">Dashboard Operativo</span>
          <span className="hc-option-desc">
            Monitoreo detallado de un sitio — tanque, gráficas, alertas
          </span>
        </button>
        <button className="hc-option" onClick={() => onChoose("B")}>
          <span className="hc-option-icon">🏛️</span>
          <span className="hc-option-label">Portafolio Institucional</span>
          <span className="hc-option-desc">
            Vista consolidada de todas las instalaciones, mapa y KPIs
          </span>
        </button>
      </div>
    </div>
  </div>
);

const Home = () => {
  const { user } = useContext(AuthContext);
  const [choice, setChoice] = useState(null); // "A" | "B" | null

  if (!user) return null;

  // type 1 (Cliente): directo a su Dashboard A, sin preguntar nada.
  if (user.type === 1) return <DashboardA />;

  // type 0 (Admin) y type 2 (Donante): eligen vista al entrar.
  if (!choice) {
    return <DashboardChooser onChoose={setChoice} />;
  }

  return choice === "A" ? (
    <DashboardA onSwitchDashboard={() => setChoice(null)} />
  ) : (
    <DashboardB onSwitchDashboard={() => setChoice(null)} />
  );
};

export default Home;